import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const getChatInterfaceSettings = async (id) => {
  return catchAxiosError(
    axiosInstance
      .get(`/admin/bot-interface-details/${id}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const saveChatInterfaceSettings = async (id, payload) => {
  return catchAxiosError(
    axiosInstance
      .put(`/admin/update-chatbot-interface/${id}`, payload)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const uploadFile = async (id, payload) => {
  return catchAxiosError(
    //axios
    //.post(`http://10.164.2.67:5000/admin/logo/${id}`, payload, {
    axiosInstance
      .post(`/admin/update-logo/${id}`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data', // Important for file uploads.
        },
      })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
